export default __webpack_public_path__ + "static/media/expocebu-4.0d6aa650.jpg";